'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ReportIcon from '@mui/icons-material/Report';
const defaultAlertIconMap = {
    info: (_jsx(InfoIcon, { "aria-label": 'Info:', titleAccess: 'Info:' })),
    success: (_jsx(CheckCircleIcon, { "aria-label": 'Success:', titleAccess: 'Success:' })),
    warning: (_jsx(WarningIcon, { "aria-label": 'Warning:', titleAccess: 'Warning:' })),
    error: (_jsx(ReportIcon, { "aria-label": 'Error:', titleAccess: 'Error:' }))
};
export const getAlertIcon = (variant = 'info', overrides) => ({
    ...defaultAlertIconMap,
    ...overrides
}[variant]);
